export default __webpack_public_path__ + "static/privacy-mojo-be1b945f3491fc8bd50dc6fc8f87c3af.svg";